module.exports = __webpack_public_path__ + "static/media/beta.03a52e99.png";